import SlidingCardGridConfig from "./sliding-card-grid-config";
import SlidingCardGridAdvancedConfig from "./sliding-card-grid-advanced-config";
import dynamic from "next/dynamic";
const SlidingCardGridComponent = dynamic(()=>import("./sliding-card-grid-component"));
export default {
    SlidingCardGridComponent,
    SlidingCardGridConfig,
    SlidingCardGridAdvancedConfig
};
